import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  modal: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
    borderRadius: '16px',
    background: '#f5f5f5',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '560px',
  },
  body: {
    display: 'flex',
    padding: '1rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    borderRadius: '12px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    background: '#FAFAFA',
    alignSelf: 'stretch',
  },
});



// WEBPACK FOOTER //
// ./src/views/components/Modal/ESignatureStyles.js